import { _, ts } from '_core';

import { DraftParams, INTERACTION_PARAMS } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.EXPORT_PORTFOLIO_HOLDINGS,
    form: true,
    title: 'Export Portfolio Holdings',
    neededFiles: ['backtest_app_portfolio_export'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.EXPORT_PORTFOLIO_HOLDINGS],
    defaultParams: {} as DraftParams,
    interactionParams: Object.values(INTERACTION_PARAMS),
    validate: (params: DraftParams) => {
      if (_.isEmpty(params)) return ['The widget needs to be configured to export the holdings.'];
      if (params.sync_with_portfolios_app && !params.app_portfolio_id)
        return ['A portfolio must be selected to export the holdings.'];
      return [];
    },
    helpLabel: 'x2heat22',
  },
] satisfies ts.types.analysis.WidgetConfig[];
